/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Hakkimizda_EyebrowInputs */

const tr_hakkimizda_eyebrow = /** @type {(inputs: Hakkimizda_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hakkımızda`)
};

const en_hakkimizda_eyebrow = /** @type {(inputs: Hakkimizda_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`About Us`)
};

const de_hakkimizda_eyebrow = /** @type {(inputs: Hakkimizda_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Über uns`)
};

const ru_hakkimizda_eyebrow = /** @type {(inputs: Hakkimizda_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`О нас`)
};

/**
* | output |
* | --- |
* | "About Us" |
*
* @param {Hakkimizda_EyebrowInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const hakkimizda_eyebrow = /** @type {((inputs?: Hakkimizda_EyebrowInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Hakkimizda_EyebrowInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_hakkimizda_eyebrow(inputs)
	if (locale === "de") return de_hakkimizda_eyebrow(inputs)
	if (locale === "ru") return ru_hakkimizda_eyebrow(inputs)
	return tr_hakkimizda_eyebrow(inputs)
});